import {applyMiddleware, createStore, compose} from 'redux';
import reduxThunk from 'redux-thunk';
import reducers from './reducers/Index';

const store= createStore(
    reducers,
    compose(
        applyMiddleware(reduxThunk),
        window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : f => f)
);
export default store;


// WEBPACK FOOTER //
// ./src/store.js